// extracted by mini-css-extract-plugin
export var pillWrapper = "_jz-0";
export var showOverflow = "_jz-1";